__webpack_require__.p = "/o/merkur-2021-frontend-loader/assets/";